import { IMicrofrontendManifest as IMicrofrontendManifestRaw } from '@cian/mf-registry/shared';

import { IMicrofrontendManifest } from '../../types/microfrontendManifest';

export const mapManifestForComponent = (manifest: IMicrofrontendManifestRaw | null): IMicrofrontendManifest | null => {
  if (!manifest) {
    return null;
  }

  const { microfrontendName, imageVersion, runtimeName, instanceId } = manifest;

  return {
    name: microfrontendName,
    image: imageVersion,
    runtime: runtimeName,
    instance: instanceId,
  };
};
